import { Component, Ref, Watch } from 'vue-property-decorator'
import GridHeader from '@/components/GridHeader.vue'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import BillingGridActionsCasesComponent from '@/modules/billing-module/components/grid/components/actions/cases/billing-grid-actions-cases.vue'
import BillingGridActionsCases from '@/modules/billing-module/components/grid/components/actions/cases/billing-grid-actions-cases'
import BillingGridActionsConceptsComponent from '@/modules/billing-module/components/grid/components/actions/concepts/billing-grid-actions-concepts.vue'
import BillingGridActionsConcepts from '@/modules/billing-module/components/grid/components/actions/concepts/billing-grid-actions-concepts'
import BillingGridActionsCopaymentsComponent from '@/modules/billing-module/components/grid/components/actions/copayments/billing-grid-actions-copayments.vue'
import BillingGridActionsCopayments from '@/modules/billing-module/components/grid/components/actions/copayments/billing-grid-actions-copayments'
import BillingGridActionsDeliveryNotesComponent from '@/modules/billing-module/components/grid/components/actions/delivery-notes/billing-grid-actions-delivery-notes.vue'
import BillingGridActionsDeliveryNotes from '@/modules/billing-module/components/grid/components/actions/delivery-notes/billing-grid-actions-delivery-notes'
import BillingGridActionsInvoicesComponent from '@/modules/billing-module/components/grid/components/actions/invoices/billing-grid-actions-invoices.vue'
import BillingGridActionsInvoices from '@/modules/billing-module/components/grid/components/actions/invoices/billing-grid-actions-invoices'
import BillingGridActionsInvoicePaymentsComponent from '@/modules/billing-module/components/grid/components/actions/invoice-payments/billing-grid-actions-invoice-payments.vue'
import BillingGridActionsInvoicePayments from '@/modules/billing-module/components/grid/components/actions/invoice-payments/billing-grid-actions-invoice-payments'
import BillingGridActionsInvoiceReceiptsComponent from '@/modules/billing-module/components/grid/components/actions/invoice-receipts/billing-grid-actions-invoice-receipts.vue'
import BillingGridActionsInvoiceReceipts from '@/modules/billing-module/components/grid/components/actions/invoice-receipts/billing-grid-actions-invoice-receipts'
import BillingGridBottomPanelComponent from '@/modules/billing-module/components/grid/components/bottom-panel/billing-grid-bottom-panel.vue'
import BillingGridBottomPanel from '@/modules/billing-module/components/grid/components/bottom-panel/billing-grid-bottom-panel'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import BaseCrudServerSideComponent from '@/shared/resources/base-crud-server-side.component'
import { BaseCrud } from '@/shared/models/cruds.models'
import {
    BillingGridState,
    getFilterModelDateField,
    initialBillingGridState
} from '@/modules/billing-module/components/grid/billing-grid.model'
import {
    billingGridDatasourceFactory,
    BillingGridResponse,
    BillingGridType
} from '@/modules/billing-module/components/grid/config/datasources/billing-grid-datasource-factory'
import { EntityIdentifiersRequest } from '@/shared/models/http/http.model'
import {
    FilterChangedEvent,
    GridReadyEvent,
    MenuItemDef,
    SelectionChangedEvent
} from '@ag-grid-enterprise/all-modules'
import { ReportGridRequest } from '@/api/services/common.dto'
import { AxiosResponse } from 'axios'
import { CommonExportType, ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { GridUtils } from '@/shared/util/grid-utils'
import { BillingStoreHelper } from '@/modules/billing-module/store/billing-store.helper'
import { StrictNullable } from '@/shared/types/app.types'
import { SidebarTimeFilterType } from '@/components/sideBar/filters/time-filter/sidebar-filters-time-filter.model'
import BillingSearcher from '@/modules/billing-module/components/searcher/billing-searcher.vue'
import { differenceBy } from 'lodash'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { ModalUtils } from '@/shared/util/modal-utils'
import { caseState } from '@/api/resources/entityState/case-state'

@Component({
    components: {
        BillingSearcher,
        GridHeader,
        GridDisplayOptions,
        BillingGridActionsCasesComponent,
        BillingGridActionsConceptsComponent,
        BillingGridActionsCopaymentsComponent,
        BillingGridActionsDeliveryNotesComponent,
        BillingGridActionsInvoicesComponent,
        BillingGridActionsInvoicePaymentsComponent,
        BillingGridActionsInvoiceReceiptsComponent,
        BillingGridBottomPanelComponent,
        VtGrid
    }
})
export default class BillingGrid extends BaseCrudServerSideComponent<BillingGridResponse> implements BaseCrud {
    @Ref() readonly casesActions!: BillingGridActionsCases
    @Ref() readonly conceptsActions!: BillingGridActionsConcepts
    @Ref() readonly copaymentsActions!: BillingGridActionsCopayments
    @Ref() readonly deliveryNotesActions!: BillingGridActionsDeliveryNotes
    @Ref() readonly invoicesActions!: BillingGridActionsInvoices
    @Ref() readonly invoicePaymentsActions!: BillingGridActionsInvoicePayments
    @Ref() readonly invoiceReceiptsActions!: BillingGridActionsInvoiceReceipts
    @Ref() readonly bottomPanel!: BillingGridBottomPanel

    state: BillingGridState
    constructor() {
        super()
        this.state = initialBillingGridState()
    }

    /// GRID COMPUTED ///

    get sidebarSelectedOptionUiComponent(): string | undefined {
        return BillingStoreHelper.sidebarSelectedOption?.uicomponent ??
            BillingStoreHelper.sidebarSelectedParentOption?.uicomponent
    }
    get sidebarSelectedOptionId(): string {
        return `${BillingStoreHelper.sidebarSelectedOption?.id}`
    }
    get sidebarTimeFilter(): SidebarTimeFilterType {
        return BillingStoreHelper.sidebarTimeFilter
    }

    get gridTitle(): string {
        const label = BillingStoreHelper.sidebarSelectedOption
            ? this.$tc(BillingStoreHelper.sidebarSelectedOption.label)
            : ''
        const parentLabel = BillingStoreHelper.sidebarSelectedParentOption
            ? this.$tc(BillingStoreHelper.sidebarSelectedParentOption.label)
            : null

        if (parentLabel) {
            return `${parentLabel} - ${label}`
        }
        return label
    }
    get gridSubtitle(): string {
        if (this.state.selectedRows.length) {
            const choice = this.state.selectedRows.length > 1 ? 2 : 1
            return `${this.state.selectedRows.length} ${this.$tc('global.selectedElements', choice)}`
        }
        return ''
    }
    get rowModel(): string {
        return this.state.gridOptions.rowModelType ?? ''
    }

    get isGridForCases(): boolean {
        return BillingStoreHelper.gridType === BillingGridType.CASES
    }
    get isGridForConcepts(): boolean {
        return BillingStoreHelper.gridType === BillingGridType.CONCEPTS
    }
    get isGridForCopayments(): boolean {
        return BillingStoreHelper.gridType === BillingGridType.COPAYMENTS
    }
    get isGridForDeliveryNotes(): boolean {
        return BillingStoreHelper.gridType === BillingGridType.DELIVERY_NOTES
    }
    get isGridForInvoices(): boolean {
        return BillingStoreHelper.gridType === BillingGridType.INVOICES
    }
    get isGridForInvoicePayments(): boolean {
        return BillingStoreHelper.gridType === BillingGridType.INVOICE_PAYMENTS
    }
    get isGridForInvoiceReceipts(): boolean {
        return BillingStoreHelper.gridType === BillingGridType.INVOICE_RECEIPTS
    }

    get visibleBottomPanel(): boolean {
        return this.isGridForCases && !!this.state.visibleSidePanel && !!this.state.clickedRow
    }

    @Watch('sidebarSelectedOptionId')
    private async _onSidebarSelectedOptionChanged(): Promise<void> {
        await this._initGrid()
    }

    @Watch('sidebarTimeFilter')
    private _onSidebarFilterModelChanged(): void {
        this._setFilterModel(BillingStoreHelper.filterModel)
    }

    private async _initGrid(): Promise<void> {
        this.state.gridUiComponent = this.sidebarSelectedOptionUiComponent ?? ''
        this.state.rowData = []
        this.state.selectedRows = []
        this.state.clickedRow = null
        this.state.datasource =
            billingGridDatasourceFactory.getDatasource(
                store.state.labId,
                BillingStoreHelper.gridType,
                BillingStoreHelper.category)
        this.state.columnsDef = this.state.datasource?.columnDefs ?? []
        this.state.gridOptions.columnDefs = this.state.columnsDef
        this.state.gridOptions.rowModelType = AgGridRowModelType.SERVER_SIDE

        this.$_cleanSearchState()
        await BillingStoreHelper.resetGridState()
    }

    private _setFilterModel(filterModel: StrictNullable<Record<string, any>>): void {
        if (this.state.gridApi) {
            const dateField = getFilterModelDateField()
            if (dateField) {
                this.state.gridApi.setFilterModel({
                    ...filterModel,
                    [dateField]: GridUtils.getTimeFilterModel(this.sidebarTimeFilter)
                })
            } else {
                this.state.gridApi.setFilterModel(filterModel)
            }
        }
    }

    /// VUE HOOKS ///

    async mounted(): Promise<void> {
        // load the states needed for the grid entity status column filter
        await PromiseUtils.toCallUnique(caseState.loadStates())

        await this._initGrid()
    }

    /// AG GRID HOOKS ///

    /** @override */
    onGridReady(event: GridReadyEvent): void {
        this.state.gridApi = event.api
        this.state.columnApi = event.columnApi

        if (this.state.gridOptions.rowModelType === AgGridRowModelType.SERVER_SIDE) {
            if (this.state.datasource) {
                this._setFilterModel(BillingStoreHelper.filterModel)
                this.state.gridApi.setServerSideDatasource(this.state.datasource)
            }
        } else {
            this.state.gridApi.setRowData(this.state.rowData ?? [])
            this.state.gridApi.selectAll()
        }
    }

    /** @override */
    onSelectionChanged({ api }: SelectionChangedEvent): void {
        this.state = {
            ...this.state,
            selectedRows: api.getSelectedRows()
        }
        BillingStoreHelper.masterSelectedRows = api.getSelectedRows()
    }

    /** @override */
    onFilterChanged({ api }: FilterChangedEvent): void {
        api.deselectAll()
        BillingStoreHelper.filterModel = api.getFilterModel()
    }

    reloadGrid(): void {
        this.state.gridOptions.rowModelType = AgGridRowModelType.SERVER_SIDE
        this.$nextTick(() => this.reloadData())
    }

    /// GRID EVENT HANDLERS ///

    onClearFilter(): void {
        this._setFilterModel(null)
    }

    closeBottomPanel(): void {
        this.state.visibleSidePanel = false
        this.state.clickedRow = null
    }

    async exportReport(exportType: CommonExportType): Promise<AxiosResponse<Blob> | null> {
        const columns = this.getColumnsToExport()
        if (columns && this.state.gridApi && this.state.datasource?.exporter) {
            const entityIdentifiersRequest: EntityIdentifiersRequest = {
                entityIdentifiers: this.state.selectedRows.map(selectedRow => selectedRow.id)
            }
            const request: ReportGridRequest = {
                sectionLabel: this.gridTitle,
                columns,
                entityIdentifiersRequest,
                filterModel: this.state.gridApi.getFilterModel()
            }
            const params: ExportCommonParams = {
                sort: GridUtils.getSortValue(this.state.gridApi.getSortModel()),
                exportType
            }
            return this.state.datasource.exporter(request, params)
        }
        return null
    }

    onSearchSuccess(elements: BillingGridResponse[]): void {
        if (this.state.rowData) {
            const elementsToAdd = differenceBy(elements, this.state.rowData, 'id')
            if (elementsToAdd.length === 0) {
                ModalUtils.showWarningModal(this.$tc('component.searcher.error.elementAlreadyAdded'))
            } else {
                this.state.rowData.push(...elementsToAdd)

                if (this.state.gridOptions.rowModelType === AgGridRowModelType.CLIENT_SIDE) {
                    if (this.state.gridApi) {
                        const previousNodes = this.state.gridApi.getRenderedNodes()

                        this.state.gridApi.setRowData(this.state.rowData)
                        if (this.state.rowData.length > 1) {
                            elements.forEach(element => {
                                if (this.state.gridApi) {
                                    GridUtils.keepSelectionGridWhenSearch(
                                        this.state.gridApi,
                                        element.id,
                                        previousNodes)
                                }
                            })
                        }
                    }
                } else {
                    this.state.gridOptions.rowModelType = AgGridRowModelType.CLIENT_SIDE
                }
            }
        }
    }

    getContextMenuItems(): MenuItemDef[] {
        const menuItems: MenuItemDef[] = []
        switch (BillingStoreHelper.gridType) {
        case BillingGridType.CASES:
            menuItems.push(...this.casesActions.getContextMenuItems())
            break
        case BillingGridType.CONCEPTS:
            menuItems.push(...this.conceptsActions.getContextMenuItems())
            break
        case BillingGridType.COPAYMENTS:
            menuItems.push(...this.copaymentsActions.getContextMenuItems())
            break
        case BillingGridType.DELIVERY_NOTES:
            menuItems.push(...this.deliveryNotesActions.getContextMenuItems())
            break
        case BillingGridType.INVOICES:
            menuItems.push(...this.invoicesActions.getContextMenuItems())
            break
        case BillingGridType.INVOICE_PAYMENTS:
            menuItems.push(...this.invoicePaymentsActions.getContextMenuItems())
            break
        case BillingGridType.INVOICE_RECEIPTS:
            menuItems.push(...this.invoiceReceiptsActions.getContextMenuItems())
            break
        }
        return menuItems
    }
}
